(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/theme-helpers/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/themes/theme-helpers/assets/javascripts/prescript.js'); 
(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.dateTime = svs.themes.dateTime || {};
})(svs);

 })(window);